import { HttpMethod } from '@vision/ui/enums';
import { TicketManagerApiRequest } from '../ticket-manager.api';

const TICKET_MANAGER_INNER_LOOP_ENDPOINT = '/v2/inner_loop';

interface TicketManagerTicketCreateConversationRequestDto {
  channel_id: string;
  detail: Record<string, never>;
  kind: 'email';
  message: {
    content: string;
    parent_id: null;
    to: string;
  };
  subject: string;
}

interface TicketManagerTicketCreateConversationMessageRequestDto {
  content: string;
  to: string;
}

export const buildTicketManagerTicketConversationsRequest = ({
  projectId,
  ticketId,
}: {
  projectId: string;
  ticketId: string;
}): TicketManagerApiRequest => ({
  method: HttpMethod.GET,
  url: `${TICKET_MANAGER_INNER_LOOP_ENDPOINT}/${projectId}/tickets/${ticketId}/conversations?kind=email`,
});

export const buildTicketManagerTicketConversationMessagesRequest = ({
  conversationId,
  projectId,
  query = '',
  ticketId,
}: {
  conversationId: string;
  projectId: string;
  query?: string;
  ticketId: string;
}): TicketManagerApiRequest => {
  const queryString = new URLSearchParams(query).toString();

  return {
    method: HttpMethod.GET,
    url: `${TICKET_MANAGER_INNER_LOOP_ENDPOINT}/${projectId}/tickets/${ticketId}/conversations/${conversationId}/messages${
      queryString ? `?${queryString}` : ''
    }`,
  };
};

export const buildTicketManagerTicketCreateConversationRequest = ({
  channelId,
  content,
  projectId,
  subject,
  ticketId,
  to,
}: {
  channelId: string;
  content: string;
  projectId: string;
  subject: string;
  ticketId: string;
  to: string;
}): TicketManagerApiRequest => {
  const data: TicketManagerTicketCreateConversationRequestDto = {
    channel_id: channelId,
    detail: {},
    kind: 'email',
    message: {
      content,
      parent_id: null,
      to,
    },
    subject,
  };

  return {
    data,
    method: HttpMethod.POST,
    url: `${TICKET_MANAGER_INNER_LOOP_ENDPOINT}/${projectId}/tickets/${ticketId}/conversations`,
  };
};

export const buildTicketManagerTicketCreateConversationMessageRequest = ({
  content,
  conversationId,
  projectId,
  ticketId,
  to,
}: {
  content: string;
  conversationId: string;
  projectId: string;
  ticketId: string;
  to: string;
}): TicketManagerApiRequest => {
  const data: TicketManagerTicketCreateConversationMessageRequestDto = {
    content,
    to,
  };

  return {
    data,
    method: HttpMethod.POST,
    url: `${TICKET_MANAGER_INNER_LOOP_ENDPOINT}/${projectId}/tickets/${ticketId}/conversations/${conversationId}/messages`,
  };
};
